import classes from './CarouselControl.module.css.mjs';

const carouselControlSizeClasses = {
  small: classes.carouselControlSizeSmall,
  large: classes.carouselControlSizeLarge
};

export { carouselControlSizeClasses };
